module.exports = __webpack_public_path__ + "img/xls.00ea3e0d.svg";